import React from "react";

// Marks a task that is a repeat visit to a stage. The badge belongs on the
// live PENDING/IN_PROGRESS row, not on the closed RETURNED/REJECTED one — the
// closed row never appears in anyone's queue, so colouring it would not help
// an assignee spot rework waiting on them.
//
// reworkKind distinguishes the two ways a stage comes round again:
//   RETURNED — a later stage sent the project back here
//   REJECTED — this stage's own submission was sent back to be redone
export default function ReworkBadge({ task }) {
  if (!task?.isRevisit) return null;

  const isRedo = task.reworkKind === "REJECTED";

  return (
    <span
      className="rework-badge"
      title={
        isRedo
          ? "Sent back for rework on this stage"
          : "Returned here from a later stage"
      }
    >
      ↩ Rework · Visit {task.visitNumber}
    </span>
  );
}

export function ReworkReason({ task }) {
  if (!task?.isRevisit || !task.reworkReason) return null;

  return (
    <div className="rework-reason">
      <strong>
        {task.reworkKind === "REJECTED"
          ? "Rework reason:"
          : "Sent back because:"}
      </strong>{" "}
      {task.reworkReason}
    </div>
  );
}
